import styled from '@emotion/styled';

export default styled.img(props => ({
  width: props.width || '100%',
  objectFit: props.objectFit || 'cover',
  height: props.height || 'auto',
  borderRadius: props.radius || 0
}));
